export const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const normalizeDisplayValue = (value) => {
    if (value == null) {
        return '';
    }
    if (typeof value === 'string' || typeof value === 'number') {
        return String(value).trim();
    }
    return '';
};

export const isUuidLike = (value) => {
    const normalizedValue = normalizeDisplayValue(value);
    if (!normalizedValue) {
        return false;
    }
    return UUID_PATTERN.test(normalizedValue);
};

export const sanitizeDisplayName = (value, fallback = '') => {
    const normalizedValue = normalizeDisplayValue(value);
    if (!normalizedValue || isUuidLike(normalizedValue)) {
        return fallback;
    }
    return normalizedValue;
};

export const firstResolvedDisplayName = (values, fallback = '') => {
    const candidates = Array.isArray(values) ? values : [];
    for (const value of candidates) {
        const resolvedValue = sanitizeDisplayName(value);
        if (resolvedValue) {
            return resolvedValue;
        }
    }
    return fallback;
};
